import { environment } from '@bvl-admin/environments/environment';

export class PermissionEndpoint {
  public static permissionsList = `${environment.LOAD_BALANCER}/permission/list`;
}
